// @flow
import { connect } from 'react-redux';
import Orders from './Orders';
import { subscriptionsToActivateWithPlanSelector } from '../../../../modules/Subscriptions';
import { goToSimActivation } from '../../../../modules/Navigation/actions';
import { deliveryResourcesLinkedWithActivableSubscriptionSelector } from '../../../../modules/DeliveryResource/selectors';
import { fetchDashboardData } from '../../../../modules/Dashboard';
import { isLoadingSelector } from '../../../../modules/LoadingStatus';
import type { DispatchProps, StateProps } from './Orders';
import type { StateType } from '../../../../modules/reducers';
import { fetchWalletForfeitureData, walletForfeitureDataSelector } from '../../../../modules/Wallet/';
import { balanceSelector } from '../../../../modules/Customer/selectors';

const mapStateToProps = (state: StateType): StateProps => ({
  dateToCallWalletForfeiture: walletForfeitureDataSelector(state).dateToCallWalletForfeiture,
  deliveryResources: deliveryResourcesLinkedWithActivableSubscriptionSelector(state, true),
  isLoading: isLoadingSelector(state, 'dashboard'),
  subscriptionsToActivateWithPlan: subscriptionsToActivateWithPlanSelector(state),
  walletBalance: balanceSelector(state),
});

const mapDispatchToProps: DispatchProps = {
  goToSimActivation,
  fetchDashboardData,
  fetchWalletForfeitureData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
